(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2yJoz", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1dd1f84932d862b0$export$6503ec6e8aabbaf; }, function (v) { return $1dd1f84932d862b0$export$6503ec6e8aabbaf = v; });
var $1dd1f84932d862b0$export$6503ec6e8aabbaf;
var $1dd1f84932d862b0$export$f7ad0328861e2f03;
"use strict";
var $1dd1f84932d862b0$var$mapping = new Map();
function $1dd1f84932d862b0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1dd1f84932d862b0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1dd1f84932d862b0$var$resolve(id) {
    var resolved = $1dd1f84932d862b0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1dd1f84932d862b0$export$6503ec6e8aabbaf = $1dd1f84932d862b0$var$register;
$1dd1f84932d862b0$export$f7ad0328861e2f03 = $1dd1f84932d862b0$var$resolve;

});

parcelRegister("luG8Y", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $fa5d172bf3f32d83$export$bdfd709ae4826697; }, function (v) { return $fa5d172bf3f32d83$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $fa5d172bf3f32d83$export$5a759dc7a1cfb72a; }, function (v) { return $fa5d172bf3f32d83$export$5a759dc7a1cfb72a = v; });
var $fa5d172bf3f32d83$export$bdfd709ae4826697;
var $fa5d172bf3f32d83$export$c9e73fbda7da57b6;
var $fa5d172bf3f32d83$export$5a759dc7a1cfb72a;
"use strict";
var $fa5d172bf3f32d83$var$bundleURL = {};
function $fa5d172bf3f32d83$var$getBundleURLCached(id) {
    var value = $fa5d172bf3f32d83$var$bundleURL[id];
    if (!value) {
        value = $fa5d172bf3f32d83$var$getBundleURL();
        $fa5d172bf3f32d83$var$bundleURL[id] = value;
    }
    return value;
}
function $fa5d172bf3f32d83$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $fa5d172bf3f32d83$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $fa5d172bf3f32d83$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $fa5d172bf3f32d83$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$fa5d172bf3f32d83$export$bdfd709ae4826697 = $fa5d172bf3f32d83$var$getBundleURLCached;
$fa5d172bf3f32d83$export$c9e73fbda7da57b6 = $fa5d172bf3f32d83$var$getBaseURL;
$fa5d172bf3f32d83$export$5a759dc7a1cfb72a = $fa5d172bf3f32d83$var$getOrigin;

});

var $81fbd05e5ea9fb27$exports = {};


(parcelRequire("2yJoz")).register((parcelRequire("luG8Y")).getBundleURL("91fY1"), JSON.parse('["91fY1","composition.82601ba1.js","hkwov","metronomeworker.293edca0.js","8kSxM","worker.948a5941.js","52oKS","imgtestlatdemo.92f5146f.webp"]'));

})();
//# sourceMappingURL=composition.runtime.ee6dae9d.js.map
